module.exports = __webpack_public_path__ + "img/icon-search-lightgray.d0bcafd2.svg";